export const SET_AND_SHOW_CURRENCY = 'SET_AND_SHOW_CURRENCY';
export function setAndShowCurrency({ currency }) {
    return { type: SET_AND_SHOW_CURRENCY, currency };
}
